<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Exit_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <path
        id="Path_8175"
        data-name="Path 8175"
        d="M17.657,6.343a8,8,0,1,1-11.314,0M12,4v8"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
